<nz-breadcrumb nzSeparator=">">
  <nz-breadcrumb-item *ngFor="let item of breadcrumbs">
    <a
      *ngIf="item.path"
      [routerLink]="item.path"
      [queryParams]="item.queryParams"
    >
      {{ item.queryParams ? "Return to search results" : item.label }}
    </a>
    <span *ngIf="!item.path">{{
      (product$ | async)?.bundle ? "Bundle Details" : item.label
    }}</span>
  </nz-breadcrumb-item>
</nz-breadcrumb>
<div class="page-container" nz-row>
  <div class="left-container">
    <leap-product-main-details-skeleton
      *ngIf="
        (getProductDetailsPending$ | async) ||
        (dictionaryFetchingPending$ | async)
      "
    ></leap-product-main-details-skeleton>

    <leap-main-details
      *ngIf="
        !(dictionaryFetchingPending$ | async) &&
          !(getProductDetailsPending$ | async) &&
          (getProductDetailsSuccess$ | async) &&
          product$ | async as product
      "
      [id]="product.id"
      [sku]="product.sku"
      [name]="product.name"
      [type]="product?.typeConfig?.configValue"
      [suffix]="product.suffix"
      [price]="product.price"
      [currency]="product.currency"
      [sellerName]="product.seller?.displayName"
      [seller]="product.seller"
      [restriction]="product.restriction"
      [restrictionMessage]="product.details?.productSegment?.restrictionMessage"
      [shortDescription]="product.shortDescription"
      [variants]="product.productVariants"
      [selectedVariant]="selectedVariant$ | async"
      [languages]="languages$ | async"
      [deliveryFormats]="deliveryFormats$ | async"
      [certificateTypes]="certificateTypes$ | async"
      [expiringContract]="expiringContract$ | async"
      [courseDeliveryFormats]="product?.courseDeliveryFormatsConfig"
      [isBundleType]="product?.typeConfig?.configKey === 'bundle-product'"
      [bundle]="product.bundle"
    ></leap-main-details>

    <leap-tabs
      [tabs]="tabs"
      [selectedTab]="isTabSelected(selectedTab$ | async)"
      (tabSelect)="toggleTab($event)"
    ></leap-tabs>
    <ng-container *ngTemplateOutlet="tabContentTemplate"></ng-container>
    <ng-container *ngTemplateOutlet="relatedProducts"></ng-container>
  </div>
  <div class="right-container">
    <leap-product-details-cart-form-skeleton
      *ngIf="
        (getProductDetailsPending$ | async) ||
        (dictionaryFetchingPending$ | async)
      "
    ></leap-product-details-cart-form-skeleton>
    <leap-cart-form
      *ngIf="
        !(dictionaryFetchingPending$ | async) &&
        !(getProductDetailsPending$ | async) &&
        (getProductDetailsSuccess$ | async) &&
        (product$ | async) &&
        (selectedVariant$ | async)
      "
      [profile]="profile$ | async"
      [product]="product$ | async"
      [selectedVariant]="selectedVariant$ | async"
      [isProductBundle]="isProductBundle"
      [expiringContract]="expiringContract$ | async"
      [requestEvaluationCopyPending]="requestEvaluationCopyPending$ | async"
      (updateProductDetails)="updateProductDetails($event)"
    >
    </leap-cart-form>
  </div>
</div>

<div class="layout-margin-bottom"></div>

<ng-template #tabContentTemplate>
  <div
    nz-row
    [ngSwitch]="selectedTab$ | async"
    class="margin-top-10"
    id="all-tabs"
  >
    <ng-container *ngSwitchCase="'about'">
      <leap-product-tab-content-skeleton
        *ngIf="!(product$ | async) || (dictionaryFetchingPending$ | async)"
      ></leap-product-tab-content-skeleton>
      <leap-about
        *ngIf="(product$ | async) && !(dictionaryFetchingPending$ | async)"
        [longDescription]="
          (product$ | async).longDescription ||
          (product$ | async).bundle?.description
        "
        [sellerRole]="(product$ | async).details?.productSegment?.sellerRole"
        [sellerAccreditationStatus]="
          (product$ | async).details?.productSegment?.sellerAccreditationStatus
        "
        [trainerRequirements]="
          (product$ | async).details?.productSegment?.trainerRequirements
        "
        [ipStatement]="(product$ | async).details?.ipStatement"
        [segmentsMapper]="segmentsMapper$ | async"
        [restricted]="(product$ | async).restriction?.restricted"
        [hasAccess]="(product$ | async).restriction?.hasAccess"
        [video]="videoAboutProduct"
      ></leap-about>
    </ng-container>

    <ng-container *ngSwitchCase="'course-information'">
      <div *ngIf="!isProductExam(product$ | async)">
        <leap-product-tab-content-skeleton
          *ngIf="!(product$ | async)"
        ></leap-product-tab-content-skeleton>
        <leap-course-information
          *ngIf="(product$ | async)?.details.courseInfo as courseInfo"
          [description]="courseInfo.description"
          [outline]="courseInfo.outline"
          [targetAudience]="courseInfo.targetAudience"
          [learningObjectives]="courseInfo.learningObjectives"
          [agenda]="courseInfo.agenda"
        >
        </leap-course-information>
      </div>
    </ng-container>

    <ng-container *ngSwitchCase="'content'">
      <leap-product-tab-content-skeleton
        *ngIf="productVariantDeliverablesPending$ | async"
      ></leap-product-tab-content-skeleton>
      <leap-content
        *ngIf="
          (product$ | async) &&
          (selectedVariant$ | async) &&
          (productVariantDeliverables$ | async)
        "
        [productVariantDeliverablesPending]="productVariantDeliverablesPending$"
        [selectedVariant]="selectedVariant$ | async"
        [deliverables]="productVariantDeliverables$ | async"
      ></leap-content>
    </ng-container>

    <ng-container *ngSwitchCase="'how-to-access'">
      <leap-product-tab-content-skeleton
        *ngIf="!(product$ | async)"
      ></leap-product-tab-content-skeleton>
      <leap-how-to-access
        *ngIf="product$ | async as product"
        [sellerRole]="product.details.productSegment?.sellerRole"
        [sellerAccreditationStatus]="
          product.details.productSegment?.sellerAccreditationStatus
        "
        [trainerRequirements]="
          product.details.productSegment?.trainerRequirements
        "
        [accreditationRequirements]="
          product.details.productSegment?.accreditationRequirements
        "
        [accreditationProcess]="
          product.details.productSegment?.accreditationProcess
        "
        [examInformation]="product.details.productSegment?.examInformation"
        [accreditationSegments]="product.restriction?.accreditationSegments"
        [segmentsMapper]="segmentsMapper$ | async"
        (getAccess)="getAccess($event)"
      ></leap-how-to-access>
    </ng-container>

    <ng-container *ngSwitchCase="'delivery-and-specifications'">
      <leap-product-tab-content-skeleton
        *ngIf="!(product$ | async)"
      ></leap-product-tab-content-skeleton>
      <leap-delivery-and-specifications
        *ngIf="product$ | async"
        [product]="product$ | async"
        [level]="(product$ | async)?.levelConfig?.configValue"
        [type]="(product$ | async)?.typeConfig?.configValue"
        [accessDuration]="(product$ | async)?.accessDuration"
        [accessDurationType]="
          (product$ | async)?.accessDurationType?.configValue
        "
        [courseInfo]="(product$ | async)?.details.courseInfo"
        [examInfo]="(product$ | async)?.details.examInfo"
        [selectedVariant]="selectedVariant$ | async"
        [selectedDeliveryFormatKey]="
          (selectedVariant$ | async).deliveryFormatConfig?.configKey
        "
        [instructions]="(product$ | async)?.details.instructions"
        [countryOfOrigin]="(product$ | async)?.countryOfOrigin"
        (onTabSelectCB)="toggleTab($event)"
      ></leap-delivery-and-specifications>
    </ng-container>

    <ng-container *ngSwitchCase="'media'">
      <leap-product-tab-content-skeleton
        *ngIf="!(product$ | async)"
      ></leap-product-tab-content-skeleton>
      <leap-media
        *ngIf="product$ | async as product"
        [videos]="product.videos"
        [promotionalMaterials]="product.promotionalMaterials"
      ></leap-media>
    </ng-container>

    <ng-container *ngSwitchCase="'reviews'">
      <leap-product-tab-content-skeleton
        *ngIf="!(product$ | async)"
      ></leap-product-tab-content-skeleton>
      <leap-reviews
        *ngIf="product$ | async"
        [reviews]="(product$ | async).reviews"
      ></leap-reviews>
    </ng-container>

    <ng-container *ngSwitchCase="'bundles'">
      <leap-product-tab-content-skeleton
        *ngIf="!(product$ | async)"
      ></leap-product-tab-content-skeleton>
      <leap-related-bundles
        *ngIf="product$ | async"
        [bundles]="relatedBundles$ | async"
        [pagination]="relatedBundlesPagination$ | async"
        [totalCount]="relatedBundlesTotalCount$ | async"
        [currencySignsMap]="currencySignsMap$ | async"
        (pageChanged)="relatedBundlesPageChanged($event)"
      ></leap-related-bundles>
    </ng-container>
    <ng-container *ngSwitchCase="'products'">
      <leap-product-tab-content-skeleton
        *ngIf="!(product$ | async)"
      ></leap-product-tab-content-skeleton>
      <leap-included-products
        *ngIf="product$ | async"
        [products]="includedProducts$ | async"
        [pagination]="includedProductsPagination$ | async"
        [totalCount]="includedProductsTotalCount$ | async"
        [currencySignsMap]="currencySignsMap$ | async"
        (pageChanged)="includedProductsPageChanged($event)"
      ></leap-included-products>
    </ng-container>
  </div>
</ng-template>

<ng-template #relatedProducts>
  <leap-related-products-carousel
    *ngIf="
      (relatedProducts$ | async)?.length &&
      !(dictionaryFetchingPending$ | async)
    "
    title="Related Products"
    [products]="relatedProducts$ | async"
    [currencySignsMap]="currencySignsMap$ | async"
    [isLogged]="isLogged$ | async"
    (addToCart)="addRelatedProductToCart($event)"
  >
  </leap-related-products-carousel>
</ng-template>

<leap-bottom-anchor
  [profile]="profile$ | async"
  [selectedVariant]="selectedVariant$ | async"
  [expiringContract]="expiringContract$ | async"
  [restricted]="(product$ | async)?.restriction?.restricted"
></leap-bottom-anchor>
